import axios from "axios";
import React, { useState } from "react";
import {
  CheckCircleFill,
  DashCircleFill,
  Magic,
  Trash,
  InboxFill,
} from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "../../components/shared";
import { Graph } from "../../models";
import { changeGraph, setAnswers, setGraph } from "../../store/actions";
import { graphSelector } from "../../store/selectors";
import { getExampleGraphJSON } from "../../utils";
import styles from "./RightSidebar.module.scss";

const Menu: React.FC = () => {
  const [clicked, setClicked] = useState<boolean>(false);

  const dispatch = useDispatch();

  const graph = useSelector(graphSelector);

  const importGraph = async () => {
    try {
      axios.post(
        // eslint-disable-next-line no-undef
        `${process.env.REACT_APP_URL}/graph`,

        graph,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          withCredentials: false,
        }
      );
    } catch (e: any) {
      console.log(e.message);
    }
  };

  const generateGraph = (): void => {
    const graph = Graph.fromJSON(getExampleGraphJSON(7));

    dispatch(changeGraph(graph));
  };

  const deleteGraph = () => {
    dispatch(setGraph(new Graph()));
    dispatch(setAnswers(null));
  };

  return (
    <div className={styles.right_sidebar}>
      <div className={styles.right_sidebar__events}>
        <Button
          type="button"
          className={styles.right_sidebar__events__button}
          onClick={generateGraph}
        >
          <Magic width={25} height={25} />
        </Button>
        <Button
          type="button"
          className={styles.right_sidebar__events__button}
          onClick={deleteGraph}
        >
          <Trash width={25} height={25} />
        </Button>
        {/* <Button
          type="button"
          className={styles.right_sidebar__events__button}
          onClick={importGraph}
        >
          <InboxFill width={25} height={25} />
        </Button> */}
      </div>
      <div className={styles.right_sidebar__gamemode}>
        <Link to="/game">
          <Button className={styles.right_sidebar__gamemode__button}>
            Start new game
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Menu;
